import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './lib/auth';
import { ToastProvider } from './components/ui';
import { applyTheme, loadTheme } from './lib/theme';
import { installErrorReporting, reportError } from './lib/errors';
import './index.css';

applyTheme(loadTheme());
installErrorReporting();

// Screens render inside an ErrorBoundary; this catches anything above it.
createRoot(document.getElementById('root')!, {
  onUncaughtError: (error, info) => reportError(error, 'render', info.componentStack ?? '')
}).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
